

export default class smsEditor {
    constructor() {
        return {
            scope: {
                smsService: "=",
                historyMeta: "="
            },
            template: require('../../../../views/smseditor/editor.html'),
            controller: ['$scope', '$filter', ($scope, $filter) => {

                $scope.trimSMSLength = function() {
                    var length = $scope.smsService.getSMSLength();
                    if (length > $scope.smsService.MAX_SMS * $scope.smsService.NUM_CHARS_MULTIPART_SMS) {
                        $scope.smsService.textMessage.content = $scope.smsService.textMessage.content
                            .slice(0, $scope.smsService.MAX_SMS * $scope.smsService.NUM_CHARS_MULTIPART_SMS - length);
                    }
                };

                $scope.remainChars = 0;
                $scope.numSms = 0;

                var calculateSummaryVars = function() {
                    $scope.remainChars = $scope.smsService.getRemainChars();
                    $scope.numSms = $scope.smsService.getNumSms();
                };

                $scope.emitHistoricalContentChange = function(contentId) {
                    $scope.$emit("historyContentSelect", contentId);
                };

                $scope.$watch('smsService.textMessage.content', calculateSummaryVars);
                $scope.$watch('smsService.stopMessage', calculateSummaryVars);
                $scope.$watch('smsService.textMessage.language', function(newValue, oldValue) {
                    if(newValue) {
                        $scope.$broadcast('smsEditor:language:toggle', newValue);
                        calculateSummaryVars();
                    }
                });
                $scope.$on('rmLanguages:availableLanguages', (event, availableLanguages) => {
                    $scope.availableLanguages = availableLanguages;
                });
                $scope.$on('smsEditor:language:toggle', (event, currentLanguage) => {
                    $scope.smsService.textMessage.language = currentLanguage;
                });
            }]
        };
    }
}